import InvestorOnboarding from './investor-onboarding';

export default InvestorOnboarding;
